import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Components
import { ConfigProvider, Row, Col } from "antd";
import Table from "../../../../components/organisms/table";
import {
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
} from "../../../../constants/pagination";
import { Title, Label } from "../../../../components/atoms/typography";
import PopupUserDetail from "../../../../components/custom/PopupUserDetail";

// Helpers
import { createColumns } from "./helpers/columns";

// Styles
import styles from "./purchaseHistory.module.scss";

// Assets
import transactionImg from "../../../../assets/images/transaction.png";

function Empty({ description }) {
  return (
    <div className={styles.container}>
      <img src={transactionImg} alt={description} height={120} width={120} />
      <p>{description}</p>
    </div>
  );
}

function PurchaseHistory({ data }) {
  const [paginationDetails, setPaginationDetails] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    pageNumber: DEFAULT_PAGE_NUMBER,
  });

  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user_id, setUser_id] = useState(null);

  useEffect(() => {
  }, [paginationDetails]);


  const columns = createColumns({
    showUser: (data) => handleShowUser(data),
  });

  const handleShowUser = (data) => {
    setIsModalOpen(true)
    setUser_id(data._id)
  };

  const handlePaginationChange = (newPageNumber, newPageSize) => {
    setPaginationDetails({
      pageNumber: newPageNumber,
      pageSize: newPageSize,
    });
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    setPaginationDetails({
      pageNumber: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
    });
  };

  const handleReload = () => {
    setPaginationDetails({ ...paginationDetails });
  };

  return (
    <div className={styles.container}>
      <ConfigProvider
        renderEmpty={() => <Empty description="No transactions found" />}
      >
        <Row className={styles.purchaseAnalytics}>
          <Col className={styles.packageDetail}>
            <Title className={styles.detailTitle}>Total Bookings</Title>
            <Label className={styles.detailValue}>{data.totalBookings || "0"}</Label>
          </Col>
          <Col className={styles.packageDetail}>
            <Title className={styles.detailTitle}>Total Gross Sale</Title>
            <Label className={styles.detailValue}>
              {data?.total_sale || "0"}
            </Label>
          </Col>
          <Col className={styles.packageDetail}>
            <Title className={styles.detailTitle}>Dudi Commission</Title>
            <Label className={styles.detailValue}>
              {data?.dudi_commission || "0"}
            </Label>
          </Col>

          <Col className={styles.packageDetail}>
            <Title className={styles.detailTitle}>Net Profit</Title>
            <Label className={styles.detailValue}>
              {data?.total_profit || "0"}
            </Label>
          </Col>
        </Row>
        <Table
          data={data?.payments}
          columns={columns}
          searchProps={{
            placeholder: "Search Purchase History",
          }}
          onPaginationChange={handlePaginationChange}
          onSearch={handleSearch}
          paginationOptions={{
            current: paginationDetails.pageNumber,
            total: data.totalBookings,
          }}
          loading={false}
          onReload={handleReload}
        />
      </ConfigProvider>
      <PopupUserDetail
        show={isModalOpen}
        close={() => setIsModalOpen(false)}
        userId={user_id}
      />
    </div>
  );
}

PurchaseHistory.propTypes = {
  activityId: PropTypes.string.isRequired,
};

PurchaseHistory.defaultProps = {};

export default PurchaseHistory;
